import React from 'react';
import { motion } from 'framer-motion';
const summaryItems = [{
  emoji: '📘',
  text: '5 Tomos PDF con +300 módulos paso a paso'
}, {
  emoji: '🤖',
  text: '50 Prompts de IA listos para copiar y pegar'
}, {
  emoji: '📊',
  text: 'Sistema de anuncios para atraer consultas'
}, {
  emoji: '💬',
  text: 'Guía práctica para responder y vender por WhatsApp'
}, {
  emoji: '🗓️',
  text: 'Hoja de ruta para organizar tu implementación'
}, {
  emoji: '🖥️',
  text: 'Plantilla de landing page de conversión'
}, {
  emoji: '📈',
  text: 'Calculadora de rentabilidad'
}, {
  emoji: '📱',
  text: 'Acceso inmediato desde celular o computadora'
}, {
  emoji: '♾️',
  text: 'Acceso de por vida'
}, {
  emoji: '🔒',
  text: 'Garantía de satisfacción de 7 días'
}];
export function VisualSummary() {
  return <section className="py-10 sm:py-16 px-4 bg-green-950/30 border-y border-green-700/20" data-id="element-259">
      <div className="max-w-4xl mx-auto" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-261">
          <h2 className="text-2xl sm:text-3xl font-black text-center text-white mb-10 flex items-center justify-center gap-3 drop-shadow-lg uppercase" data-id="element-262">
            <span className="text-3xl" data-id="element-263">👑</span> TU MEGA PACK INCLUYE:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-264">
            {summaryItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="flex items-center gap-4 bg-green-950/50 p-4 rounded-xl border border-green-700/20" data-id="element-265">
                <span className="text-2xl shrink-0" data-id="element-266">{item.emoji}</span>
                <span className="font-medium text-white" data-id="element-267">{item.text}</span>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}